import store from '@/store/store';
import axios from 'axios';
class DownloadService {
    private async downloadFile(httpPath: string, body: any, filename: string) {
        // Implementation based on https://stackoverflow.com/a/24129082/5044561
        const result = await axios.post(httpPath, body, {
            responseType: 'arraybuffer'
        });
        const data = result.data;
        const octetStreamMime = 'application/octet-stream';
        let success = false;
        const headers = result.headers;

        // Determine the content type from the header or default to "application/octet-stream"
        const contentType = headers['content-type'] || octetStreamMime;

        try {
            // Try using msSaveBlob if supported
            //  \ufeff: BOM (byte order mark) for utf encoding.
            const blobSaveBlob = new Blob(['\ufeff', data], { type: contentType });
            if ((navigator as any).msSaveBlob) {
                (navigator as any).msSaveBlob(blobSaveBlob, filename);
            } else {
                // Try using other saveBlob implementations, if available
                const saveBlob =
                    (navigator as any).webkitSaveBlob || (navigator as any).mozSaveBlob || (navigator as any).saveBlob;
                if (saveBlob === undefined) {
                    throw new Error('Not supported');
                }
                saveBlob(blobSaveBlob, filename);
            }
            success = true;
        } catch (ex) {}

        if (!success) {
            // Get the blob url creator
            const urlCreator =
                window.URL || (window as any).webkitURL || (window as any).mozURL || (window as any).msURL;
            if (urlCreator) {
                // Try to use a download link
                const link = document.createElement('a');
                if ('download' in link) {
                    // Try to simulate a click
                    try {
                        // Prepare a blob URL
                        const blobUrlCreator = new Blob(['\ufeff', data], {
                            type: contentType
                        });
                        const urlUrlCreator = urlCreator.createObjectURL(blobUrlCreator);
                        link.setAttribute('href', urlUrlCreator);

                        // Set the download attribute (Supported in Chrome 14+ / Firefox 20+)
                        link.setAttribute('download', filename);

                        // Simulate clicking the download link
                        const event = document.createEvent('MouseEvents');
                        event.initMouseEvent(
                            'click',
                            true,
                            true,
                            window,
                            1,
                            0,
                            0,
                            0,
                            0,
                            false,
                            false,
                            false,
                            false,
                            0,
                            null
                        );
                        link.dispatchEvent(event);
                        success = true;
                    } catch (ex) {}
                }
                if (!success) {
                    // Fallback to window.location method
                    try {
                        // Prepare a blob URL
                        // Use application/octet-stream when using window.location to force download
                        const blobWindow = new Blob(['\ufeff', data], {
                            type: octetStreamMime
                        });
                        const urlWindow = urlCreator.createObjectURL(blobWindow);
                        window.location = urlWindow;
                        success = true;
                    } catch (ex) {}
                }
            }
        }
        if (!success) {
            // Fallback to window.open method
            window.open(httpPath, '_blank', '');
        }
    }

    public downloadUserExportFile() {
        const personIds = store.state.dataFiltersManager.allFiltersMerger.filteredData.map(person => person.Id);
        const body: { personIds: string[] } = { personIds };
        this.downloadFile(store.state.root._links.export.href, body, 'beeHiveResultSet.csv');
    }
}

export const downloadService = new DownloadService();
